import {
  BD_GET_INCOTERMCITY_LISTING,
  BD_GET_INCOTERMCITY_LISTING_SUCCESS,
  BD_GET_INCOTERMCITY_LISTING_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    bdIncotermCity: null,
  }
  
  const bdIncotermCity = (state = initialState, action) => {
    switch (action.type) {
      case BD_GET_INCOTERMCITY_LISTING:
        state = {
          ...state,
          loading: true,
          bdIncotermCity: action.payload,
        }
        break
      case BD_GET_INCOTERMCITY_LISTING_SUCCESS:
        state = { ...state, loading: false, bdIncotermCity: action.payload }
        break
      case BD_GET_INCOTERMCITY_LISTING_FAILED:
        state = { ...state, loading: false }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default bdIncotermCity
  